module.exports = __webpack_public_path__ + "img/EmitidaIcon.0a35a672.svg";